/* Love N Care — global scroll motion: reveal-on-scroll + parallax + section progress.
   All effects respect prefers-reduced-motion and have a safety net so content never stays hidden. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  }

  function reveals(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { revealAll(root); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-lnc-delay') || '0', 10);
        if (d) el.style.transitionDelay = d + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden if IO misfires.
    setTimeout(function () { revealAll(root); }, 4000);
  }

  // Re-bind for DOM swapped in by AJAX (collection filtering, etc.)
  window.lncReveals = reveals;

  // AJAX swaps (facets filtering, cart sections) insert fresh [data-reveal] nodes that no
  // observer knows about — they'd stay at opacity 0. Watch the whole document, debounced.
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; reveals(document); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function parallax() {
    if (reduce) return;
    var items = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (!items.length) return;
    var raf = null;
    function tick() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.12;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      raf = null;
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
    tick();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function progressBars() {
    var bars = document.querySelectorAll('[data-scroll-progress]');
    if (!bars.length || reduce) return;
    function upd() {
      var h = document.documentElement;
      var p = h.scrollTop / (h.scrollHeight - h.clientHeight) * 100;
      bars.forEach(function (b) { b.style.width = p + '%'; });
    }
    upd();
    window.addEventListener('scroll', upd, { passive: true });
  }

  function init(root) { reveals(root); parallax(); progressBars(); }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { reveals(e.target); parallax(); });
})();
